const TermsModalContent = () => {
  return (
    <div className="p-4">
      <div className="mb-5 text-reliableBlack90">
        <p className="text-xs font-semibold uppercase mb-1 lg:text-sm">Pembelian Paket Servis</p>
        <p className="text-xs font-normal leading-relaxed mb-3 lg:text-sm">
          Harga pembelian aksesoris kendaraan akan ditampilkan sesuai dengan harga per item.
          Ketersediaan produk bergantung pada stok yang ada pada cabang Auto2000. Harga yang tertera
          bukan harga final dan tidak termasuk biaya pemasangan di cabang. Biaya pemasangan
          ditanggung oleh pelanggan. Ketentuan untuk transaksi pembelian aksesoris, yaitu :
        </p>
        <ul className="text-xs leading-relaxed list-decimal pl-4 lg:text-sm">
          <li>
            Pembatalan transaksi pembelian aksesoris hanya dapat dilakukan secara offline dan tidak
            dapat sepihak dengan sebelumnya Anda melakukan konfirmasi terlebih dahulu ke call center
            Auto2000 atau datang ke cabang Auto2000, dengan melengkapi mekanisme ketentuan yang
            telah ditentukan Perusahaan.
          </li>
          <li>
            Biaya yang dikenakan kepada Anda selaku pembeli belum termasuk biaya pemasangan
            aksesoris.
          </li>
          <li>
            Jaminan yang berlaku pada aksesoris sesuai dengan ketentuan garansi (Warranty)
            Perusahaan dan berlaku hanya apabila pemasangan produk dilakukan di bengkel Auto2000.
          </li>
          <li>
            Pembayaran dapat dilakukan dengan menggunakan Virtual Account, ataupun kartu debit atau
            kredit.
          </li>
          <li>
            Opsi pilih jadwal pengambilan atau pasang aksesoris di cabang dapat dipilih pelanggan
            paling cepat H+3 terhitung sejak dilakukan pembayaran.
          </li>
          <li>
            Cabang yang dapat dipilih pelanggan untuk melakukan proses pengambilan atau pemasangan
            aksesoris saat ini hanya Cabang VSP General Repair saja.
          </li>
        </ul>
      </div>

      <div className="mb-5 text-reliableBlack90">
        <p className="text-xs font-semibold uppercase mb-1 lg:text-sm">pembayaran Produk</p>
        <ul className="text-xs leading-relaxed list-decimal pl-4 lg:text-sm">
          <li>
            Pembayaran produk dan/atau layanan yang Perusahaan sediakan dapat melalui virtual
            account, kartu debit atau kredit yang diterbitkan oleh bank yang bekerjasama dengan
            Perusahaan.
          </li>
          <li>
            Pembayaran yang Auto2000 terima untuk unit kendaraan bermotor hanya melalui virtual
            account. Pembayaran menggunakan metode selain melalui virtual account tidak akan
            Perusahaan terima, dan akan menghambat proses pembelian produk dan/atau layanan yang
            Anda kehendaki.
          </li>
          <li>
            Virtual Account adalah nomor identifikasi pelanggan Perusahaan yang disediakan oleh Bank
            atas permintaan Perusahaan untuk selanjutnya diberikan oleh Perusahaan kepada Anda
            sebagai nomor rekening tujuan penerimaan (collection). Virtual Account merupakan suatu
            bentuk open payment (tidak memiliki jumlah tagihan yang pasti), di mana setiap setoran
            atas Virtual Account dibukukan oleh sistem ke rekening utama dengan mencantumkan nomor
            dan nama rekening virtual. Dengan metode ini, pembayaran akan menjadi lebih mudah, yaitu
            Anda tidak perlu melakukan konfirmasi pembayaran secara manual, melainkan sudah
            dibukukan langsung oleh sistem bank.
          </li>
          <li>
            Pembayaran dapat dilakukan dengan menggunakan Virtual Account, ataupun kartu debit atau
            kredit.
          </li>
          <li>
            Untuk pembayaran biaya layanan service, aksesoris dan/atau suku cadang, dapat dilakukan
            melalui virtual account, kartu debit atau kartu kredit yang diterbitkan oleh bank yang
            bekerjasama dengan Perusahaan. Dalam hal anda bermaksud untuk melakukan pembatalan atas
            pembayaran biaya aksesoris/suku cadang secara online, pembatalan tersebut hanya dapat
            dilaksanakan secara offline di cabang Perusahaan.
          </li>
        </ul>
      </div>

      <div className="mb-5 text-reliableBlack90">
        <p className="text-xs font-semibold uppercase mb-1 lg:text-sm">pembayaran Produk</p>
        <ul className="text-xs leading-relaxed list-decimal pl-4 lg:text-sm">
          <li>
            Pembayaran produk dan/atau layanan yang Perusahaan sediakan dapat melalui virtual
            account, kartu debit atau kredit yang diterbitkan oleh bank yang bekerjasama dengan
            Perusahaan.
          </li>
          <li>
            Pembayaran yang Auto2000 terima untuk unit kendaraan bermotor hanya melalui virtual
            account. Pembayaran menggunakan metode selain melalui virtual account tidak akan
            Perusahaan terima, dan akan menghambat proses pembelian produk dan/atau layanan yang
            Anda kehendaki.
          </li>
          <li>
            Virtual Account adalah nomor identifikasi pelanggan Perusahaan yang disediakan oleh Bank
            atas permintaan Perusahaan untuk selanjutnya diberikan oleh Perusahaan kepada Anda
            sebagai nomor rekening tujuan penerimaan (collection). Virtual Account merupakan suatu
            bentuk open payment (tidak memiliki jumlah tagihan yang pasti), di mana setiap setoran
            atas Virtual Account dibukukan oleh sistem ke rekening utama dengan mencantumkan nomor
            dan nama rekening virtual. Dengan metode ini, pembayaran akan menjadi lebih mudah, yaitu
            Anda tidak perlu melakukan konfirmasi pembayaran secara manual, melainkan sudah
            dibukukan langsung oleh sistem bank.
          </li>
          <li>
            Pembayaran dapat dilakukan dengan menggunakan Virtual Account, ataupun kartu debit atau
            kredit.
          </li>
          <li>
            Untuk pembayaran biaya layanan service, aksesoris dan/atau suku cadang, dapat dilakukan
            melalui virtual account, kartu debit atau kartu kredit yang diterbitkan oleh bank yang
            bekerjasama dengan Perusahaan. Dalam hal anda bermaksud untuk melakukan pembatalan atas
            pembayaran biaya aksesoris/suku cadang secara online, pembatalan tersebut hanya dapat
            dilaksanakan secara offline di cabang Perusahaan.
          </li>
        </ul>
      </div>
    </div>
  );
};

export default TermsModalContent;
